module.exports = __webpack_public_path__ + "static/toast-casepuctuation-dont-a09d6297c9b5bdde59f12c245ae3948c.png";